import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import BigNumber from 'bignumber.js'
import { ModerationStages } from '@/constants/backend/ModerationStages'
import { RoomTypes } from '@/constants/chat/RoomTypes'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'
import { GigStatuses } from '@/constants/gig/gigStatuses'
import { GigTimeTypes } from '@/constants/gig/gigTimeTypes'
import { SERVICE_CHAT, SERVICE_DETAILS } from '@/constants/routes'
import responseMixin from '@/mixins/responseMixin'
import snackMixin from '@/mixins/snackMixin'
import ChatRoom from '@/models-ts/chat/ChatRoom'
import GigOfferListItem from '@/models-ts/gigs/GigOfferListItem'
import MyGigApplication from '@/models-ts/gigs/MyGigApplication'
import GigApplicationStatusBadge from '@/partials/StatusBadges/GigApplicationStatusBadge/GigApplicationStatusBadge.vue'
import UserInfo from '@/partials/UserInfo/UserInfo.vue'
import { formatDate } from '@/utils/date'
import { formatUsd } from '@/utils/moneyFormat'

export default Vue.extend<any, any, any, any>({
  mixins: [responseMixin, snackMixin],
  components: {
    GigApplicationStatusBadge,
    UserInfo,
  },
  props: {
    gig: GigOfferListItem,
    application: MyGigApplication,
    isFreelancer: Boolean,
  },
  data() {
    return {
      accepting: false,
      starting: false,
      SERVICE_DETAILS,
    }
  },
  computed: {
    ...mapState({
      rates: (state: any) => state.rates.rates.value || [],
      isBalancesLoaded: (state: any) => state.balances.balances.isLoaded,
    }),
    ...mapGetters({
      backendConfig: 'user/getConfigMap',
      getUnreadCount: 'chatNew/getUnreadCount',
    }),
    customerType() {
      return this.application.customer?.customerType
    },
    hasChat() {
      return this.application.id && this.application.moderationStage === ModerationStages.PASSED
    },
    dateFormatted() {
      return formatDate(this.application.createdAt, 'DD MMM YYYY, hh:mm A')
    },
    isHourly() {
      return this.application.offer?.timeType === GigTimeTypes.HOURLY
    },
    budget() {
      return this.application.offer?.budget || this.application.budget
    },
    totalBudget() {
      if (this.rates.length) {
        return new BigNumber(this.budget).multipliedBy(this.isHourly ? this.application.offer.timeValue : 1)
      }
      return 0
    },
    budgetInUsd() {
      return formatUsd(this.totalBudget)
    },
    deadline() {
      if (this.application.offer?.deadline) {
        return `${this.application.offer.deadlineInDays} days`
      } else if (this.application.deadline) {
        return `${this.application.deadlineInDays} days`
      }
      return 'Not specified'
    },
    chatRoomId() {
      return ChatRoom.generateRoomId({
        type: RoomTypes.GIG,
        applicationId: this.application.id,
        freelancerId: this.application.freelancer.id,
        customerId: this.application.customer.id,
      })
    },
    chatLink() {
      return {
        name: SERVICE_CHAT,
        params: { id: this.application.gig.id, slug: this.application.gig.slug },
        query: { room: this.chatRoomId },
      }
    },
    unreadMsgs() {
      return this.getUnreadCount(this.chatRoomId)
    },
    user() {
      return this.isFreelancer ? this.application.customer : this.application.freelancer
    },
    hasCreateOfferBtn() {
      return this.isFreelancer && !this.application?.offer
    },
    hasStartJob() {
      return !this.isFreelancer && this.application?.offer?.stage === GigOfferStages.ACCEPTED_BY_CUSTOMER
    },
    hasAcceptBtn() {
      return !this.isFreelancer && this.application?.offer?.stage === GigOfferStages.NEW
    },
    hasGig() {
      return !this.gig.isRemoved && (this.isFreelancer || this.gig.gigStatus === GigStatuses.PUBLISHED)
    },
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
    }),
    onChatClick() {
      this.$router.push(this.chatLink)
    },
    refreshList() {
      this.$emit('refreshList')
    },
  },
})
